/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Upstream_Id_InvalidInputs */



/**
* | output |
* | --- |
* | "The server lists a model ID oneAI does not accept: at most 200 characters of letters, digits and . _ : / @ + -." |
*
* @param {Private_Models_Save_Upstream_Id_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_upstream_id_invalid = /** @type {((inputs?: Private_Models_Save_Upstream_Id_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Upstream_Id_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Server listet eine Modell-ID, die oneAI nicht annimmt: höchstens 200 Zeichen aus Buchstaben, Ziffern und . _ : / @ + -.")
	return /** @type {LocalizedString} */ ("The server lists a model ID oneAI does not accept: at most 200 characters of letters, digits and . _ : / @ + -.")
});